import { useState } from "react"
import Sidebar from "../../components/dashboard/Sidebar"
import DashboardHeader from "../../components/dashboard/HeaderDashboard"
import { Plus } from "lucide-react"
import NavigationService from "@services/navigation.service.js";
import AuthController from "@controllers/auth.controller.js";

export default function Support() {
  const [activeQuestion, setActiveQuestion] = useState(3)
  const [activeTab, setActiveTab] = useState("FAQ")

  // Define the buttons array for the tabs
  const tabButtons = ["FAQ", "Contact Us"]

  const faqItems = [
    {
      id: 1,
      question:
        "Lorem ipsum dolor sit amet. Et ipsa dolore ut dicta ipsam et pariatur sint aut molestiae quisquam! Ut similique dolore et voluptas voluptas sit illo illo est illo ?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...",
    },
    {
      id: 2,
      question:
        "Lorem ipsum dolor sit amet. Rem tenetur quae sit impedit deserunt et enim reiciendis est magnam similique ?",
      answer:
        "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur...",
    },
    {
      id: 3,
      question:
        "Vel voluptas quisquam eum provident nemo aut dolorum nobis. Ut dolorum consequatur ad enim atque eum excepturi consectetur sed dolor alias id nisi obcaeci ?",
      answer: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium...",
    },
    {
      id: 4,
      question: "Quo quidem sapiente in autem error et voluptatum quia. Et officiis enim ea fugia ?",
      answer: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit...",
    },
    {
      id: 5,
      question: "Lorem ipsum dolor sit amet. Aut totam velit ex animi adipisci et laboriosam sequi. Et numquam ?",
      answer: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit...",
    },
    {
      id: 6,
      question: "Et dolorem ipsa cum voluptas temporibus ad omnis nemo et commodi numquam ?",
      answer: "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam...",
    },
    {
      id: 7,
      question:
        "Hic voluptatem repudiandae aut sint quos eum sunt nemo in officia numquam id veniam labore sed laboriosam quae. Rem commodi ?",
      answer:
        "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque...",
    },
    {
      id: 8,
      question:
        "Et saepe dolore ut exercitationem vero id provident odio sed sapiente quam. In consectetur labore aut earum libero non quia voluptatum ut ducimus ?",
      answer: "Similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga...",
    },
  ]

  const handleCreateStudy = () => {
    NavigationService.navigateTo("/create-study")
  }

  const handleSignOut = () => {
    AuthController.logout();
  }

  const toggleQuestion = (id) => {
    setActiveQuestion((prev) => (prev === id ? null : id))
  }

  return (
    <div className="flex h-screen bg-dashboard-bg">
      <Sidebar
        title="OSHIMED"
        activeLink="Support"
        companyName="Company Name"
        onCreateStudy={handleCreateStudy}
        onSignOut={handleSignOut}
      />

      <div className="flex-1 flex flex-col overflow-hidden p-4 md:p-6 lg:p-8">
        <DashboardHeader
          title="Support"
          buttons={tabButtons}
          activeButton={activeTab}
          onButtonClick={(tab) => setActiveTab(tab)}
        />

        <div className="flex-1 overflow-auto bg-dashboard-bg">
          <div className="flex-1 mt-2 rounded-xl bg-dashboard-bg1">
            <main className="p-3 sm:p-4 md:p-6">
              {activeTab === "FAQ" && (
                <>
                  <h2 className="text-lg font-semibold mb-4 md:mb-6">Frequently asked questions</h2>

                  <div className="space-y-0">
                    {faqItems.map((item) => (
                      <div key={item.id} className="border-b border-[#4D7BFF]">
                        <div
                          className="py-4 flex justify-between items-center cursor-pointer"
                          onClick={() => toggleQuestion(item.id)}
                        >
                          <h3 className="text-gray-800 pr-8">{item.question}</h3>
                          <div
                            className={`flex items-center justify-center w-8 h-8 rounded-full ${
                              activeQuestion === item.id ? "bg-[#FF5C5C] text-white" : "bg-[#E6EDFF] text-[#4D7BFF]"
                            }`}
                          >
                            <Plus
                              className={`h-5 w-5 transition-transform ${
                                activeQuestion === item.id ? "rotate-45" : "rotate-0"
                              }`}
                            />
                          </div>
                        </div>
                        {activeQuestion === item.id && (
                          <div className="pb-4 text-gray-700 animate-fadeIn">{item.answer}</div>
                        )}
                      </div>
                    ))}
                  </div>
                </>
              )}

              {activeTab === "Contact Us" && (
                // Empty for now as per requirements
                <div className="min-h-[200px] flex items-center justify-center text-gray-500">
                  Contact Us section will be implemented soon.
                </div>
              )}
            </main>
          </div>
        </div>
      </div>
    </div>
  )
}
